const data = {
    "status": true,
    "data": {
        "logo": "https://app.mindhouse.com//static/uploads/group_1xxd0NJ.png",
        "heroSection": [
            {
                "bgImage": "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/hero-9a286d3864cf4abc9163ab853bb73238.png",
                mobBgImage: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/HeroMob-ecf9d51a14ea4990a5f6b0f6c8da1254.png",
                "title": "Minimal <span>Ingredients.</span><br/> Maximum <span>Impact.</span>",
                "description": "Built on simplicity and transparency. Clean, short ingredient lists with no fillers, no harmful additives - just performance.",
                ctaLink: "https://shop.betheshyft.com/collections/all"
            }
        ],
        "faqs": {
            "title": "Common questions",
            "faqs": [
                {
                    "question": "What is Shyft?",
                    "sub_title": "",
                    "answer": "At Shyft, we create the highest quality products and services for better health. Our health products are available across India and our online services (nutrition consultations) can be accessed globally"
                },
                {
                    "question": "What are the products and services offered by Shyft?",
                    "sub_title": "",
                    "answer": "We offer online Nutrition consultations. We have recently launched our range of health products with Plant Protein Isolate in Natural Cocoa as our first product. Our health products are crafted with a focus on quality and simplicity. We use only all-natural ingredients and keep our formulations minimal to ensure you get the most benefit."
                },
                {
                    "question": "How do you ensure the quality of your products and services?",
                    "sub_title": "",
                    "answer": "Our products and services are developed by global experts. We work closely with our community and customers for feedback on every product and service before we go live to ensure you only get the best. Our products are also rigorously tested in certified laboratories."
                }
            ]
        },
        "supplementStore": {
            products: [
                { name: 'Plant Protein Isolate: Natural Cocoa', weight: '500g', price: '1620', image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_5-d45787d960a6416aa5d8a0ede3973ce6.png',link: "https://shop.betheshyft.com/products/plant-protein-isolate-natural-cocoa" },
                { name: 'Plant Protein Isolate: Vanilla', weight: '500g', price: '1800', image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_6-50971e5ac7024a6abde3ca303c0f7dae.png',link: "https://shop.betheshyft.com/products/plant-protein-isolate-vanilla" },
                { name: 'Rapid Hydration - Mixed Flavours', weight: '9 Sachets', price: '400', image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_8-f167aa2f754e44d9ab4e0c37d33894b9.png', link: "https://shop.betheshyft.com/products/rapid-hydration-mixed-flavours-9-sachets" },
                { name: 'Fermented Yeast Protein: Chocolate', weight: '500g', price: '1800', image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_7-fed3d4040c8940908601dc44b8b332a5.png', link: "https://shop.betheshyft.com/products/fermented-yeast-protein-chocolate" },
            ],
            categories: [
                { title: 'Plant Protein Isolate', subtitle: 'Made with Pea & Brown Rice', image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container-b10e2011e527439c8aa849cbccbe7e92.png',link: "https://shop.betheshyft.com/collections/protein-powder-flavours" },
                { title: 'Electrolytes', subtitle: 'Rapid Hydration', image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/ImageWithFallback-49e7bc7b704246fca365c7a37b0700fa.png',link: "https://shop.betheshyft.com/collections/electrolytes" },
                { title: 'Fermented Yeast Protein', subtitle: 'Vegan & Lactose Free', image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/ImageWithFallback_1-e00d81c0f748492ab799b085fd08f3e1.png', link: "https://shop.betheshyft.com/collections/fermented-yeast-protein" },
            ]
        },
        productHero: {
            tabContent: {
                'Plant Protein Isolate': {
                    title: 'Purest Plant Protein',
                    link: 'https://shop.betheshyft.com/collections/plant-protein-isolate/',
                    bgImage: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/ImageWithFallback_4-df93373773a94063be2702120db4bf42.png',
                    mobImage: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/ImageWithFallback_4-df93373773a94063be2702120db4bf42.png",
                    description: 'A clean, gut-friendly formula with minimal ingredients, delivering maximum protein per scoop while supporting faster muscle recovery.',
                    stats: [
                        { value: '5', label: 'INGREDIENTS' },
                        { value: '0g', label: 'ADDED SUGAR' },
                        { value: '100%', label: 'PLANT BASED' },
                    ]
                },
                'Electrolytes': {
                    title: 'Designed to absorb faster than regular hydration drinks',
                    link: 'https://shop.betheshyft.com/collections/electrolytes',
                    bgImage: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Section-6c08b9711629491aac8a0058066078a9.png',
                    mobImage: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Section_5_1-4fe8dbbae62e4f8b9d617401e80452c4.png",
                    description: 'Fast-hydrating, low-sugar hypotonic formula that replenishes key electrolytes for balance and recovery.',
                    stats: [
                        { value: '3', label: 'essential salts' },
                        { value: '1hr', label: 'salt loss replenished' },
                        { value: '100%', label: 'TRANSPARENT' },
                    ]
                },
                'Fermented Yeast Protein': {
                    title: 'Whey-Like Absorption. Smooth Texture. 100% Vegan Protein.',
                    link:'https://shop.betheshyft.com/collections/fermented-yeast-protein',
                    bgImage: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Section_1_1-9ea33a92dde3491ab4a6c299c8b775a1.png',
                    mobImage: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Section_4_1-a9963168ae6746a48fdc2a8d43f1d1b4.png",
                    description: 'A smooth, non-grainy vegan protein with complete amino acid profile, high bioavailability, and enhanced digestibility.',
                    stats: [
                        { value: '5', label: 'INGREDIENTS' },
                        { value: '0g', label: 'ADDED SUGAR' },
                        { value: '100%', label: 'TRANSPARENT' },
                    ]
                }
            },
            features: [
                { icon: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_14-3246f6cca0ee48b59f25366ecb3f0663.png', label: 'Third-party tested' },
                { icon: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_15-a3a077c74ffe4d6c8912943b87b719b4.png', label: 'Global experts' },
                { icon: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_16-1e36e8bed29144e182092aa2041a77d4.png', label: 'Community tested' },
                { icon: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_17-6bd8bd49f24d452a8cd832d0dfec8d19.png', label: 'Minimal ingredients' },
            ]
        },
        testimonials: {
            athleteData: [
                {
                    name: "Sugandha Mishra",
                    role: "Hybrid Athlete",
                    achievement: "Hyrox Podium Finisher",
                    quote: "Shyft rapid hydration tastes amazing, gives good energy and helps in maintaining energy.",
                    img: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container-bcdfa08ded1e403fb88d0d0deb94f226.png"
                },
                {
                    name: "Megha Kishore",
                    role: "Runner & Hybrid Athlete",
                    achievement: "Marathon Medalist & Hyrox Podium Finisher",
                    quote: "Shyft electrolytes is simple, effective, and exactly what my body needs in the heat as an athlete.",
                    img: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_1-0d4a7de1e28143a39ad7faa40f9ffc08.png"
                },
                {
                    name: "Liza Resa",
                    role: "Runner",
                    achievement: "7 x Marathon Runner",
                    quote: "I’ve been using Shyft Electrolytes, and the difference is noticeable. It keeps me well-hydrated, helps prevent cramps, and sustains my energy through long endurance workouts.",
                    img: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_2-7e3d83fee8aa4766a73feac5a52e3613.png"
                },
                {
                    name: "Likhit Shivaprasad",
                    role: "Runner",
                    achievement: "100 KM Ultra runner",
                    quote: "Shyft rapid hydration is my go-to mid day hydration partner!",
                    img: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_3-eb187c17ee98431dab7bc18ac4b166aa.png"
                },
                {
                    name: "Sanjay Dasila",
                    role: "Runner",
                    achievement: "Marathon Runner",
                    quote: "Shyft is the best hydration for me in this summers.",
                    img: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_4-99563916b59941f289a8e6d8a759182c.png"
                },
                {
                    name: " Amorto Das",
                    role: "Runner",
                    achievement: " Hyrox Athlete",
                    quote: "Shyft is the best hydration for me in this summers.",
                    img: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_5-5b622d8a88504a56bbdbf3919fc99db7.png"
                },
                {
                    name: " Vaishnavi Patel",
                    role: "Hybrid Athlete",
                    achievement: " Hyrox Athlete",
                    quote: "So grateful to Shyft for being a part of my training journey. I love the products!",
                    img: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/ImageWithFallback-fbd0bfd749b546c39e80275bb1b14e8e.png"
                }
            ],
            userReviews: [
                {
                    text: "No more bloating after my morning protein shake. Shyft changed the game for me.",
                    author: "PRIYA R. • MUMBAI",
                    age: "25 yrs."
                },
                {
                    text: "Clean ingredients, no BS. Exactly what I was looking for in a supplement brand.",
                    author: "VIKRAM S. • BANGALORE",
                    age: "25 yrs."
                },
                {
                    text: "Clean ingredients, no BS. Exactly what I was looking for in a supplement brand.",
                    author: "VIKRAM S. • BANGALORE",
                    age: "25 yrs."
                }
            ]
        },
        bundles: [
            {
                title: 'Vanilla (Pack of 2)',
                description: '2 × 500 g',
                price: '2916',
                image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/plant-protein-isolate-vanilla-pack-of-2-442848-0f1b327b95414f7797c3.webp',
                link: "https://shop.betheshyft.com/products/plant-protein-isolate-vanilla-pack-of-2"
            },
            {
                title: 'Unflavoured (Pack of 2)',
                description: '2 × 500 g',
                price: '2430',
                image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/plant-protein-isolate-unflavoured-pack-of-2-639058-d54658b5285544ec.webp',
                link: "https://shop.betheshyft.com/products/plant-protein-isolate-unflavoured-pack-of-2"
            },
            {
                title: 'Natural Cocoa & Vanilla (Pack of 2 Flavours)',
                description: '2 × 500 g',
                price: '2916',
                image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/1-b1eca0c918824faf911a0d2ace2a57ad.jpg',
                link: "https://shop.betheshyft.com/products/plant-protein-isolate-natural-cocoa-vanilla-combo"
            },
            {
                title: 'Vanilla & Unflavoured (Pack of 2 Flavours)',
                description: '2 × 500 g',
                price: '2673',
                image: 'https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/1_1-94d99d95c61a45a28efd284ededeab0f.jpg',
                link: "https://shop.betheshyft.com/products/plant-protein-isolate-vanilla-unflavoured-pack-of-2-flavours"
            }
        ]
    }
};

export default data;
